import { render, staticRenderFns } from "./notifications.html?vue&type=template&id=1b558f2d&scoped=true&external"
import script from "./notifications.vue?vue&type=script&lang=ts"
export * from "./notifications.vue?vue&type=script&lang=ts"
import style0 from "./notifications.scss?vue&type=style&index=0&id=1b558f2d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b558f2d",
  null
  
)

export default component.exports